import { useState, useEffect, useCallback, createContext, useContext } from 'react';
import { getMyCompanyPlan, checkFeatureAccess } from '../services/api';
import { useAuth } from '../context/AuthContext';

const PlanContext = createContext(null);

export const PlanProvider = ({ children }) => {
    const [plan, setPlan] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { user } = useAuth();

    const refreshPlan = useCallback(async () => {
        setLoading(true);
        try {
            const data = await getMyCompanyPlan();
            setPlan(data);
            setError(null);
        } catch (err) {
            setError(err.response?.data?.error || 'خطا در دریافت اطلاعات پلن');
            setPlan(null);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        if (user) {
            refreshPlan();
        } else {
            setPlan(null);
            setError(null);
            setLoading(false);
        }
    }, [user, refreshPlan]);

    const hasAccess = useCallback(async (featureSlug) => {
        try {
            const data = await checkFeatureAccess(featureSlug);
            return data.has_access;
        } catch {
            return false;
        }
    }, []);

    const isSuspended = plan?.status === 'suspended' || plan?.status === 'expired';
    const walletBalance = plan?.wallet_balance ?? 0;
    const isWalletLow = plan?.wallet_health?.is_low ?? false;

    return (
        <PlanContext.Provider value={{
            plan, loading, error, refreshPlan,
            hasAccess, isSuspended, walletBalance, isWalletLow,
        }}>
            {children}
        </PlanContext.Provider>
    );
};

export const usePlan = () => {
    const ctx = useContext(PlanContext);
    if (!ctx) throw new Error('usePlan must be used within PlanProvider');
    return ctx;
};

export default usePlan;
